require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./granit-fensterbank.json") })
        }
      }, "path---granit-fensterbank");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---granit-fensterbank!./.cache/json/granit-fensterbank.json
// module id = 451
// module chunks = 231608221292675